import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import upcomingEventInterface from "../../infra/aggregates/upcomingEventsInterface";
// Define a type for the slice state

// Define the initial state using that type

const upcomingEventsSlice = createSlice({
  name: "upcomingEvent",

  initialState: { events: [], eventLoader: false },
  reducers: {
    upcomingEventsReducer: (
      state: any,
      action: PayloadAction<upcomingEventInterface[]>
    ) => {
      state.events = action.payload;
    },
    upcomingEventsLoader: (state: any, action: PayloadAction<any>) => {
      state.eventLoader = action.payload;
    },
  },
});

export const { upcomingEventsReducer, upcomingEventsLoader } =
  upcomingEventsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default upcomingEventsSlice.reducer;
